var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechStackLevel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16151_682196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 10L7 13L13 10M1 7L7 10L13 7M7 1L1 4L7 7L13 4L7 1Z",
    stroke: "#2C74D6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_16151_682196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 21.8333H16.7833V19.6167H18.5V17.4H20.2167V15.1667H21.8333V14.1667H19.2167V16.3833H17.5V18.6H15.7833V20.8333H14.1667V21.8333ZM13 24C12.7333 24 12.5 23.9 12.3 23.7C12.1 23.5 12 23.2667 12 23V13C12 12.7333 12.1 12.5 12.3 12.3C12.5 12.1 12.7333 12 13 12H23C23.2667 12 23.5 12.1 23.7 12.3C23.9 12.5 24 12.7333 24 13V23C24 23.2667 23.9 23.5 23.7 23.7C23.5 23.9 23.2667 24 23 24H13ZM13 23H23V13H13V23ZM13 23V13V23Z",
    fill: "#2C74D6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16151_682196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_16151_682196"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 12,
    height: 12,
    rx: 1,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechStackLevel);
export default "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cg clip-path='url(%23clip0_16151_682196)'%3e %3cpath d='M1 10L7 13L13 10M1 7L7 10L13 7M7 1L1 4L7 7L13 4L7 1Z' stroke='%232C74D6' stroke-linecap='round' stroke-linejoin='round'/%3e %3cg clip-path='url(%23clip1_16151_682196)'%3e %3cpath d='M14.1667 21.8333H16.7833V19.6167H18.5V17.4H20.2167V15.1667H21.8333V14.1667H19.2167V16.3833H17.5V18.6H15.7833V20.8333H14.1667V21.8333ZM13 24C12.7333 24 12.5 23.9 12.3 23.7C12.1 23.5 12 23.2667 12 23V13C12 12.7333 12.1 12.5 12.3 12.3C12.5 12.1 12.7333 12 13 12H23C23.2667 12 23.5 12.1 23.7 12.3C23.9 12.5 24 12.7333 24 13V23C24 23.2667 23.9 23.5 23.7 23.7C23.5 23.9 23.2667 24 23 24H13ZM13 23H23V13H13V23ZM13 23V13V23Z' fill='%232C74D6'/%3e %3c/g%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0_16151_682196'%3e %3crect width='24' height='24' fill='white'/%3e %3c/clipPath%3e %3cclipPath id='clip1_16151_682196'%3e %3crect x='12' y='12' width='12' height='12' rx='1' fill='white'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };